import React, { useEffect, useState } from 'react'

import { BottomSheet, Icon, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { CustomSelectOption } from '../customSelectOption'
import { InputWithLabel } from '../inputWithLabel'
import { B26 } from '../typography'

interface SelectDropDownProps {
  label?: string
  placeholder?: string
  onChange: (value: string) => void
  onBlur: () => void
  value?: string
  errorMessage?: string
  dropOptions?: any
  example: string
  iconLeft?: string
}

export const SelectDropDownBottomSheet: React.FC<SelectDropDownProps> = ({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value = '',
  errorMessage,
  dropOptions,
  example,
  iconLeft,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value)
  const [isSheetVisible, setIsSheetVisible] = useState<boolean>(false)

  function selectOption(value: string) {
    setIsSheetVisible(false)
    onSelect('', value)
    setSelectedValue(value)
  }

  function closeBottomsheet() {
    setIsSheetVisible(false)
  }

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  const onSelect = (val: string, displayText: string) => {
    setSelectedValue(displayText)
    onChange(displayText)
    onBlur()
  }

  return (
    <Stack className="mb-3">
      <Pressable className="-mb-4" onPress={() => setIsSheetVisible(true)}>
        <InputWithLabel
          example={example}
          onChange={() => null}
          isEditable={false}
          placeholder={placeholder}
          onBlur={onBlur}
          iconRight={'ArrowDown'}
          iconLeft={iconLeft}
          value={value}
          label={label}
          errorMessage={errorMessage}
          pointerEvents="none"
          isFocused={isSheetVisible}
        />
      </Pressable>

      {isSheetVisible && (
        <BottomSheet
          visible={isSheetVisible}
          onDismiss={closeBottomsheet}
          snapPoints={[280]}
        >
          <>
            <XStack className="items-center justify-between px-3 py-2">
              <XStack className="items-center">
                <B26>{label}</B26>
              </XStack>
              <Pressable onPress={closeBottomsheet}>
                <Icon size={24} type="Close" />
              </Pressable>
            </XStack>
            <Stack className="px-3">
              {dropOptions?.[0]?.fields?.map(({ key, displayValue }: any) => (
                <CustomSelectOption
                  key={key}
                  value={key}
                  displayText={displayValue}
                  selectedValue={selectedValue}
                  onSelect={() => selectOption(displayValue)}
                />
              ))}
            </Stack>
          </>
        </BottomSheet>
      )}
    </Stack>
  )
}
